.onboarding-option {
    padding: 8px 8px 8px 0;
}

.onboarding-option label {
    padding-left: 6px;
    font-size: var(--font-normal);
}
